<template lang="pug">
  v-container
    v-col
      v-row
        h3 Aprobación de órdenes de compra
      v-row
        v-card( width='100%' )
          v-card-text
            Tabla_ordenes_de_compras( :es_administrador='true' )
    v-col
      v-row
        h3 Aprobación de requermientos
      v-row
        v-card( width='100%' )
          v-card-text
            Tabla_de_requerimientos( :es_administrador='true' ) 

</template>
<script>
export default {
  components:{
    Tabla_de_requerimientos: ()=>import('@/views/cotizaciones/componentes/tabla_de_requerimientos'),
    Tabla_ordenes_de_compras: () => import('@/views/cotizaciones/componentes/tabla_ordenes_de_compras'),
  }
}
</script>
